
import Vue from 'vue'
import { DataSet } from '@/services/DataSet'

export default Vue.extend({
   name: 'FilterText',
   props: {
      title: String,
      dataset: Object as () => DataSet,
      size: { type: String, default: 'input-sm' },
      placeholder: { type: String, default: 'Filter' },
   },
   data() {
      return {
         filterValue: '',
      }
   },
   methods: {
      clearFilter() {
         this.filterValue = ''
         this.notifyFilterChanged()
      },
      notifyFilterChanged() {
         this.$emit('change', this.filterValue)
      },
      notifyFilterInput() {
         this.$emit('input', this.filterValue)
      },
   },
})
